/* global process */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
export default class PopoverProvider extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.showPopover = popoverContent => {
            if (process.env.BROWSER) {
                return ReactDOM.createPortal(popoverContent, this.portalEl);
            }
            PopoverProvider.ssrContent = popoverContent;
            return null;
        };
    }
    getChildContext() {
        return { showPopover: this.showPopover };
    }
    get portalEl() {
        if (process.env.BROWSER) {
            return document.getElementById('popover-portal');
        }
        return null;
    }
    render() {
        const { children } = this.props;
        return children;
    }
}
PopoverProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
PopoverProvider.childContextTypes = {
    showPopover: PropTypes.func.isRequired,
};
PopoverProvider.ssrContent = null;
